__turbopack_context__.v({
  "backgroundImage": "index-module-scss-module__JWxi9a__backgroundImage",
  "backgroundPicture": "index-module-scss-module__JWxi9a__backgroundPicture",
  "card": "index-module-scss-module__JWxi9a__card",
  "cardDescription": "index-module-scss-module__JWxi9a__cardDescription",
  "cardTitle": "index-module-scss-module__JWxi9a__cardTitle",
  "cardsGrid": "index-module-scss-module__JWxi9a__cardsGrid",
  "container": "index-module-scss-module__JWxi9a__container",
  "contentPanel": "index-module-scss-module__JWxi9a__contentPanel",
  "eyebrow": "index-module-scss-module__JWxi9a__eyebrow",
  "foregroundFrame": "index-module-scss-module__JWxi9a__foregroundFrame",
  "foregroundImage": "index-module-scss-module__JWxi9a__foregroundImage",
  "gridWrap": "index-module-scss-module__JWxi9a__gridWrap",
  "icon": "index-module-scss-module__JWxi9a__icon",
  "iconBadge": "index-module-scss-module__JWxi9a__iconBadge",
  "marquee": "index-module-scss-module__JWxi9a__marquee",
  "marqueeTrack": "index-module-scss-module__JWxi9a__marqueeTrack",
  "mediaStage": "index-module-scss-module__JWxi9a__mediaStage",
  "outfitCard": "index-module-scss-module__JWxi9a__outfitCard",
  "outfitImage": "index-module-scss-module__JWxi9a__outfitImage",
  "section": "index-module-scss-module__JWxi9a__section",
  "stylist-match-marquee": "index-module-scss-module__JWxi9a__stylist-match-marquee",
  "title": "index-module-scss-module__JWxi9a__title",
});
